<template>
<label class="toggle-container">
    <input type="checkbox" v-model="modelValue" @change="$emit('change', modelValue)" />
    <span class="slider"></span>
    <span class="label-text" width="60xp">{{ modelValue ? 'Unsubscribe' : 'Subscribe' }}</span>
</label>
</template>

<script>
export default {
    name: 'ToggleSwitch',
    props: {
        value: Boolean
    },
    computed: {
        modelValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
};
</script>

<style scoped>
.toggle-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 8px;
}

.toggle-container input {
    display: none;
}

.slider {
    width: 36px;
    height: 20px;
    background-color: #ccc;
    border-radius: 20px;
    position: relative;
    transition: background-color 0.3s;
}

.slider::before {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    left: 2px;
    top: 2px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s;
}

input:checked+.slider {
    background-color: #3f51b5;
    /* indigo */
}

input:checked+.slider::before {
    transform: translateX(16px);
}

.label-text {
    font-size: 14px;
    font-weight: 500;
    width: 100px;
}
</style>
